import Vue from "vue";
import { mapGetters } from "vuex";

Vue.mixin({
  computed: {
    ...mapGetters(["ALL_USER_LIST"]),
  },
  methods: {
    numberDeclension(value, words) {
      const valueMath = Math.abs(value) % 100;
      var num = valueMath % 10;
      if (valueMath > 10 && valueMath < 20) return `${value} ${words[2]}`;
      if (num > 1 && num < 5) return `${value} ${words[1]}`;
      if (num == 1) return `${value} ${words[0]}`;
      return `${value} ${words[2]}`;
    },
    // Определение формата файла
    fileExtension(url) {
      return (url.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
    },
    // Определение имени пользователя по ID
    userNameId(user_id) {
      let name = "Аноним";
      if (this.ALL_USER_LIST) {
        this.ALL_USER_LIST.forEach(user => {
          if (user.value === user_id) {
            name = user.text;
          }
        });
      }

      return name;
    },
  },
});
